import React from "react";
import { Box, ThemeProvider, CssBaseline } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import FloatingButtons from "./FloatingButtons";
import webTheme from "../../theme/web-theme";
import { Helmet } from "react-helmet";

const WebLayout = ({ children }) => {
    return (
        <ThemeProvider theme={webTheme}>
            <CssBaseline />
            <Helmet>
                <link
                    href="https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap"
                    rel="stylesheet"
                />
            </Helmet>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                }}
                >
                <Header />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: 'url("/assets/bg-waving.png")',
                        backgroundRepeat: 'repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'contain'
                    }}
                >
                    {children}
                </Box>
                <Footer />
                <FloatingButtons />
            </Box>
        </ThemeProvider>
    );
};

export default WebLayout;
